
import HomePage from '../pages/home/page';
import ProductsPage from '../pages/products/page';
import ContactPage from '../pages/contact/page';
import FAQPage from '../pages/faq/page';
import NotFound from '../pages/NotFound';
import AdminPage from '../pages/dashboard/page';
import CategoriesPage from '../pages/dashboard/categories/page';
import AdminBannersPage from '../pages/dashboard/banners/page';
import AdminFAQPage from '../pages/dashboard/faq/page';
import AdminSettingsPage from '../pages/dashboard/settings/page';
import AdminProductsPage from '../pages/dashboard/products/page';
import AdminCategoriesPage from '../pages/dashboard/categories/page';
import OrdersManager from '../pages/dashboard/order/page';
import PaymentCallback from '../pages/order/PaymentCallback';
import OrderSuccess from '../pages/order/OrderSuccess';

const routes = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/products/:category',
    element: <ProductsPage />
  },
  {
    path: '/payment/success',
    element: <PaymentCallback />
  },
  {
    path: '/order-success/:id',
    element: <OrderSuccess />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/pheee',
    element: <AdminPage />
  },
  {
    path: '/pheee/products',
    element: <AdminProductsPage />
  },
  {
    path: '/pheee/orders',
    element: <OrdersManager />
  },
  {
    path: '/pheee/categories',
    element: <AdminCategoriesPage />
  },
  {
    path: '/pheee/banners',
    element: <AdminBannersPage />
  },
  {
    path: '/pheee/faq',
    element: <AdminFAQPage />
  },
  {
    path: '/pheee/settings',
    element: <AdminSettingsPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
